export default {
  base_url: "http://localhost:8000"
};
